import React, { FunctionComponent, useEffect, useState } from "react";
import { url } from "../../Values/constants";
import axios from "axios";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import {
    Box,
    Button,
    Grid,
    Dialog,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import "../../theme-vars.css";
import InputTextValue from "../../Components/TextInput/InputTextValue";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import StyledCancelButton from "../../Components/Buttons/StyledCancelButton";
import Modal, { Styles } from "react-modal";
import { themeColors } from "../../Components/theme";

type props = {
    history: any;
    openDialog: any;
    setOpenDialog: any;
    userDetails: any;
    bookingType?: any;
    setReason?: any;
    authToken: any;
    theme?: any;
};
const FormDialog: FunctionComponent<props> = ({
    history,
    openDialog,
    setOpenDialog,
    userDetails,
    bookingType,
    setReason,
    authToken,
    theme
}) => {
    const dispatcher = useDispatch();
    const themeMUI = useTheme();
    const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
    const [contactNumber, setContactNumber] = useState<any>();
    const [textReason, setTextReason] = useState<any>();

    const handleSubmit = async () => {
        if (bookingType === "EDIT") {
            setReason(textReason);
            textReason && setOpenDialog(false);
        }
        else {
            const bodyData = {
                organization_id: userDetails.organization_id,
                uid: userDetails.uid,
                contact_no: contactNumber,
            }
            axios.defaults.headers.common['x-access-token'] = authToken

            const getBookingContactNORes = await axios.post(
                url + '/bookings/details',
                bodyData
            );
            if (getBookingContactNORes.data) {
                history.push({
                    pathname: '/addBooking',
                    state: { "booking_type": "REBOOKING", "reBookingData": bodyData }
                })
            }
            else {
                dispatcher(
                    showSnackbarAction(
                        "No matching record(s) found for Bookings, you have searched for !!!",
                        "error"
                    )
                );
            }
        }
    }

    const modalStyle: Styles = {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)", // darkens the background
            zIndex: 1300, // higher than MUI AppBar/Table
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        content: {
            background: theme
                ? themeColors.cardBackgroundColor
                : themeColors.cardBackgroundColorDark,
            color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
            borderRadius: 16,
            padding: isMobile ? "24px 12px" : "40px 32px",
            maxWidth: 380,
            minWidth: 320,
            // minHeight: 320,
            border: "none",
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            inset: "auto",
            margin: "auto",
        },
    };

    return (
        <Modal
            isOpen={openDialog}
            onRequestClose={() => setOpenDialog(false)}
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc={true}
            style={modalStyle}
            ariaHideApp={false}
        >
            <Box sx={{
                width: "100%",
                maxWidth: 340,
                mx: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}>
                <form style={{ width: "100%" }}>
                    <Box sx={{ mb: 2 }}>
                        <h3
                            style={{
                                color: theme ? "#272944" : "#fff",
                                fontFamily: "var(--font-family-main)",
                                fontSize: "var(--font-size-large)",
                                marginBottom: 24,
                                textAlign: "center",
                                fontWeight: 700,
                                letterSpacing: 0.5,
                            }}
                        >
                            {bookingType === "EDIT" ? "Reason" : "Create Re-Booking"}
                        </h3>
                    </Box>
                    <Grid container spacing={2} sx={{ width: "100%" }}>
                        <Grid item xs={12}>
                            {bookingType === "EDIT" ? (
                                <InputTextValue
                                    title="Reason"
                                    value={textReason}
                                    onChange={(e) => setTextReason(e.target.value)}
                                    required={true}
                                />
                            ) : (
                                <InputTextValue
                                    title="Contact Number"
                                    value={contactNumber}
                                    onChange={(e) => setContactNumber(e.target.value)}
                                    required={true}
                                />
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    mt: 2,
                                    width: "100%",
                                }}
                            >
                                <Box style={{ marginRight:8 }}>
                                    <StyledCancelButton
                                        onClick={() => setOpenDialog(false)}
                                        isMobile={isMobile}
                                    >
                                        Cancel
                                    </StyledCancelButton>
                                </Box>
                                <Box>
                                    <StyledSubmitButton
                                        onClick={handleSubmit}
                                        themeMode={themeMUI.palette.mode}
                                        isMobile={isMobile}
                                    >
                                        Submit
                                    </StyledSubmitButton>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </Modal>
    );
}

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        theme: state.theme.isLightMode,
        authToken: state.user.authToken,
    };
};
export default connect(mapStateToProps)(FormDialog);